import { useState } from 'react'

import { validateEmail } from '@/utils/validations'

export type Form = {
  name: string
  email: string
  company: string
  segment: string
}
type UseFormContainerProps = {
  handleErrorMessage: (
    field: string,
    value: string,
    customValidate?: ((value: string) => boolean) | undefined,
    customErrorMessage?: string,
  ) => string | null | undefined
}
export const useFormContainer = ({
  handleErrorMessage,
}: UseFormContainerProps) => {
  const [form, setForm] = useState<Form>({
    name: '',
    email: '',
    company: '',
    segment: '',
  })

  const [submitted, setSubmitted] = useState(false)

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = e.target
    setForm({ ...form, [name]: value })
  }
  const formFields = Object.keys(form)
  const validate = formFields.map((field) => {
    let error: string | null | undefined
    if (field === 'email') {
      error = handleErrorMessage(
        field,
        form[field as keyof typeof form],
        validateEmail,
        'E-mail inválido',
      )
    } else {
      error = handleErrorMessage(field, form[field as keyof typeof form])
    }
    return error
  })
  const isExistErrors =
    validate.filter(
      (error) => error === 'E-mail inválido' || error === 'Campo obrigatório',
    ).length > 0 ||
    !form.name.trim() ||
    !form.email.trim() ||
    !form.company.trim() ||
    !form.segment.trim()

  const options = [
    { value: 'Nenhum', id: '' },
    { value: 'Agricultura', id: 'Agricultura' },
    { value: 'Alimentos e Bebidas', id: 'Alimentos e Bebidas' },
    { value: 'Automotivo', id: 'Automotivo' },
    { value: 'Beleza e Cuidados Pessoais', id: 'Beleza e Cuidados Pessoais' },
    { value: 'Construção e Engenharia', id: 'Construção e Engenharia' },
    { value: 'Educação', id: 'Educação' },
    { value: 'Eletrônicos', id: 'Eletrônicos' },
    { value: 'Energia', id: 'Energia' },
    { value: 'Entretenimento', id: 'Entretenimento' },
    { value: 'Finanças e Seguros', id: 'Finanças e Seguros' },
    { value: 'Governo e Setor Público', id: 'Governo e Setor Público' },
    { value: 'Hotelaria e Turismo', id: 'Hotelaria e Turismo' },
    { value: 'Imóveis', id: 'Imóveis' },
    { value: 'Indústria', id: 'Indústria' },
    { value: 'Internet e Tecnologia', id: 'Internet e Tecnologia' },
    { value: 'Logística e Transporte', id: 'Logística e Transporte' },
    { value: 'Moda e Vestuário', id: 'Moda e Vestuário' },
    { value: 'Saúde e Bem-estar', id: 'Saúde e Bem-estar' },
    { value: 'Serviços Profissionais', id: 'Serviços Profissionais' },
    {
      value: 'Tecnologia da Informação (TI)',
      id: 'Tecnologia da Informação (TI)',
    },
    { value: 'Telecomunicações', id: 'Telecomunicações' },
    { value: ' Outros', id: ' Outros' },
  ]

  const handleSubmitForm = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setSubmitted(true)
  }

  return {
    submitted,
    form,
    onChange,
    options,
    setForm,
    isExistErrors,
    handleSubmitForm,
  }
}
